export function normalizeCaseNumbers(caseNumberValue) {
  if (Array.isArray(caseNumberValue)) {
    return caseNumberValue
      .filter((caseNumber) => typeof caseNumber === "string")
      .map((caseNumber) => caseNumber.trim())
      .filter(Boolean);
  }

  if (typeof caseNumberValue === "string" && caseNumberValue.trim() !== "") {
    return [caseNumberValue.trim()];
  }

  return [];
}

export function encodeCaseNumberForPath(caseNumber) {
  return String(caseNumber || "").trim().replace(/\//g, "-");
}

export function decodeCaseNumberFromPath(slug) {
  const s = String(slug || "").trim();
  // Sri LR format: 1982-v1-sri-lr-90 → 1982/v1-sri-lr-90
  if (/^\d{4}-v\d/.test(s)) {
    return s.replace(/^(\d{4})-/, "$1/");
  }
  // Regular format: sc-fr-10-2012 → sc-fr-10/2012
  // Handles suffixes like -order: ca-bail-253-2025-order → ca-bail-253/2025-order
  return s.replace(/-(\d{4})([-]|$)/, "/$1$2");
}
